import { Stack, Text, Group, Textarea } from "@mantine/core"
import { Form } from "../../../../../-components/typed-form"
import { TimeInput } from "@mantine/dates"
import { CancelButton, SubmitButton } from "../../../../../-components/Buttons"
import { DateOnly, Nullable, TimeOnly } from "../../../../../@client/System"
import { useTranslation } from "react-i18next"
import { mapNullable } from "../../../../../utils/nullable"
import { ShiftTypeDto } from "../../../../../@client/Theasoft_ApiServer_ShiftTypes"

export type InitialData = {
  note: null | string
  contractId: number
  date: DateOnly
  startTime: TimeOnly | null
  endTime: TimeOnly | null
}

export function CreateShiftModal({
  initialData,
  onCancel,
  onClose,
  shiftType,
  onAdded,
}: {
  shiftType: ShiftTypeDto
  initialData: InitialData
  onCancel: () => void
  onClose: () => void
  onAdded?: () => void
}) {
  const { t } = useTranslation("app_server")
  return (
    <Form
      url="/api/DepartmentDutyRoster/AddShift"
      initialValues={initialData}
      onSuccess={() => {
        onAdded && onAdded()
      }}
      transform={(x) => ({
        shiftNote: x.note ?? "",
        shiftTypeId: shiftType.shiftTypeId,
        contractId: initialData.contractId,
        date: initialData.date,
        startTime: mapNullable(
          x.startTime,
          (time) => time + ":00"
        ) as Nullable<TimeOnly>,
        endTime: mapNullable(
          x.endTime,
          (time) => time + ":00"
        ) as Nullable<TimeOnly>,
      })}
    >
      {(f, _) => (
        <>
          <Stack>
            <Text>
              {t("Type")} {shiftType.name}
            </Text>
            <Group>
              <TimeInput
                {...f.getInputProps(_.startTime._PATH_)}
                label={t("From")}
              />
              <TimeInput
                {...f.getInputProps(_.endTime._PATH_)}
                label={t("Until")}
              />
            </Group>
            <Textarea {...f.getInputProps(_.note._PATH_)} label={t("Note")} />
            <Group justify="end">
              <CancelButton onMouseDown={() => onCancel()} />
              <SubmitButton>{t("EnterShift")}</SubmitButton>
            </Group>
          </Stack>
        </>
      )}
    </Form>
  )
}
